import { useMemo } from "react";
import { useCurrentSettings } from "./usePouchList";
import { useCurrentProject } from "./useCurrentProject";

export function useCurrentProjectConfig() {
  const project = useCurrentProject();
  const settings = useCurrentSettings();

  const loading = project.loading || settings.loading;
  const error = project.error || settings.error;
  return useMemo(() => {
    if (!project.data || !settings.data) {
      return { data: null, loading, error };
    } else {
      return {
        data: {
          config: project.data.swecomapConfig || settings.data.swecomapConfig || settings.data.config,
          piano: project.data.Piano || settings.data.Piano,
        },
        loading,
        error,
      };
    }
  }, [error, loading, project.data, settings.data]);
}
